export default {
  props: {
    title: {
      type: [String, Boolean],
      default: false,
    },
    text: {
      type: [String, Boolean],
      default: false,
    },
    badgeTheme: {
      type: String,
      default: "inverse",
    },
    badgeText: {
      type: [String, Boolean],
      default: false,
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
    badgeIcon: {
      type: [String, Boolean],
      default: false,
    },
    translateBadgeText: {
      type: Boolean,
      default: true,
    },
    imageUrl: {
      type: [String, Boolean],
      default: false,
    },
    tags: {
      type: [Array, Boolean],
      default: false,
    },
    category: {
      type: [Object, Boolean],
      default: false,
    },
    itemRoute: {
      type: [Object, Boolean],
      default: false,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: function () {
    return {};
  },
};
